import React, {useMemo} from 'react';
import styles from './BenefactorPaymentsTable.module.scss';
import {TableColumnConfig, Text} from '@gravity-ui/uikit';
import {DataTable} from '../../shared/ui/DataTable';
import {BenefactorPaymentsInfoModel} from '../../entities';

interface BenefactorPaymentsTableProps {
  payments: BenefactorPaymentsInfoModel[] | undefined;
  isLoading: boolean;
}

export const BenefactorPaymentsTable = ({payments, isLoading}: BenefactorPaymentsTableProps) => {
  const columns = useMemo<TableColumnConfig<BenefactorPaymentsInfoModel>[]>(
    () => [
      {
        id: 'cardholderName',
        name: 'Имя',
        template: (item: BenefactorPaymentsInfoModel) => (
          <div className={styles.cellContainer}>
            <Text variant="body-1">{item.type === 'CloudPaymentsSavedCard' ? item.cardholderName || '-' : '-'}</Text>
          </div>
        ),
      },
      {
        id: 'cardNumber',
        name: 'Номер',
        template: (item: BenefactorPaymentsInfoModel) => (
          <div className={styles.cellContainer}>
            <Text variant="body-1">
              {item.type === 'CloudPaymentsSavedCard'
                ? `${item.firstSix.slice(0, 4)} ${item.firstSix.slice(4, 6)}XX XXXX ${item.lastFour}`
                : '-'}
            </Text>
          </div>
        ),
      },
      {
        id: 'cardType',
        name: 'Способ оплаты',
        template: (item: BenefactorPaymentsInfoModel) => (
          <div className={styles.cellContainer}>
            <Text variant="body-1">
              {item.type === 'CloudPaymentsSavedCard'
                ? item.cardType
                : item.bankName
                  ? `Счёт СБП · ${item.bankName}`
                  : 'Счёт СБП'}
            </Text>
          </div>
        ),
      },
      {
        id: 'isDefault',
        name: 'Признак',
        template: (item: BenefactorPaymentsInfoModel) => (
          <div className={styles.cellContainer}>
            {item.isDefault ? <Text variant="body-1">По умолчанию</Text> : <Text variant="body-1">-</Text>}
          </div>
        ),
      },
    ],
    [],
  );

  return (
    <DataTable<BenefactorPaymentsInfoModel>
      isLoading={isLoading}
      data={payments || []}
      columns={columns}
      edgePadding={false}
      skeletonRowCount={3}
      emptyStateTitle="Способы оплаты не найдены"
      emptyStateDescription="У данного пользователя пока нет сохраненных способов оплаты"
    />
  );
};
